import { INavigationRoute } from '../types'

interface IRouteFilterOptions {
  excludeBase: boolean
}

export const filterRoutes = (
  routes: INavigationRoute[],
  options?: IRouteFilterOptions
): INavigationRoute[] => {
  const hashRoutes = __STAGE__ && !__STAGING_NEW__
  const { hash = '', pathname = '' } = global.location || {}
  const routeToSplit = hashRoutes ? hash : pathname
  const [, currentRoute, secondLevel] = routeToSplit.split('/')

  return routes.map(route => {
    const { childRoutes, location } = route || {}

    /**
     * Prepend base paths when applicable
     */
    if (!options?.excludeBase && !route.excludeBase) {
      route.location = `${__ROOT__}/${route.location}`
    }

    /**
     * Uses `global` object to detect if current route is active
     * @deprecated by leveraging react-router
     */
    if (location && location === currentRoute) {
      if (secondLevel) {
        route.isActive = location?.indexOf(secondLevel) > -1
      } else {
        route.isActive = true
      }
    }

    if (childRoutes) {
      route.childRoutes = filterRoutes(childRoutes, options)
    }

    return route
  })
}
